import React, { useState } from 'react'
import { IModuleBackgroundColorProps, IModulePaddingProps, ModuleSection } from '../ModuleSection/ModuleSection'
import { ICMSTextV2Props, TextV2 } from '../Text/TextV2'
import { Box, Image, SxStyleProp } from 'rebass'
import { containerStyles, faqListContainerStyles } from './FaqBlock.styles'

export interface IFaqBlockProps {
  moduleBackgroundColor: IModuleBackgroundColorProps
  modulePadding: IModulePaddingProps
  dataTestId?: string
  title: ICMSTextV2Props
  body: IQABody[]
  sx?: SxStyleProp
}

interface IQABody {
  question: ICMSTextV2Props
  answer: ICMSTextV2Props
  isOpen: boolean
}

export const FaqBlock = ({ moduleBackgroundColor, modulePadding, dataTestId, title, body }: IFaqBlockProps) => {
  const [bodyCopy, setBodyCopy] = useState([...body])

  const handleToggleClick = (index: number, value: boolean) => {
    const updatedBoy = bodyCopy.map((qa: IQABody, i: number) => (i === index ? { ...qa, isOpen: !value } : qa))
    setBodyCopy([...updatedBoy])
  }
  return (
    <ModuleSection moduleBackgroundColor={moduleBackgroundColor} modulePadding={modulePadding} dataTestId={dataTestId}>
      <Box sx={containerStyles}>
        <Box sx={{ marginBottom: '32px' }}>
          <TextV2 tag={title.tag} textFontColor={title.textFontColor} textFontStyle={title.textFontStyle}>
            {title.text}
          </TextV2>
        </Box>

        <Box sx={faqListContainerStyles}>
          {bodyCopy.map((qa, i) => (
            <Box key={i} sx={{ borderBottom: '1px solid white', paddingY: '30px' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Box sx={{ width: '85%' }}>
                  <TextV2
                    tag={qa.question.tag}
                    textFontColor={qa.question.textFontColor}
                    textFontStyle={qa.question.textFontStyle}
                  >
                    {qa.question.text}
                  </TextV2>
                </Box>
                <Image
                  src={qa.isOpen ? '/expansion-panel-close-icon.svg' : '/expansion-panel-open-icon.svg'}
                  sx={{ width: '25px', height: '25px', cursor: 'pointer' }}
                  onClick={() => handleToggleClick(i, qa.isOpen)}
                />
              </Box>

              {qa.isOpen && (
                <Box sx={{ paddingTop: '25px', width: '85%' }}>
                  <TextV2
                    tag={qa.answer.tag}
                    textFontColor={qa.answer.textFontColor}
                    textFontStyle={qa.answer.textFontStyle}
                  >
                    {qa.answer.text}
                  </TextV2>
                </Box>
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </ModuleSection>
  )
}
